import React from 'react';
import useMain from '../../hooks/useMain';

const ModeToggler = () => {
	const { theme, toggleTheme } = useMain();

	return (
		<div className='form-check form-switch d-flex justify-content-center align-items-center'>
			<label
				// htmlFor='switchCheckDefault'
				className='form-check-label'
				style={{ paddingTop: '5px' }}>
				<i
					className={`fas fa-sun ${
						theme === 'light' ? 'opacity-100 text-yellow' : 'opacity-50'
					}`}></i>
			</label>
			<input
				className='form-check-input mx-2'
				type='checkbox'
				role='switch'
				id='switchCheckDefault'
				defaultChecked={theme === 'dark'}
				onChange={toggleTheme}
			/>
			<label
				// htmlFor='switchCheckDefault'
				className='form-check-label'
				style={{ paddingTop: '5px' }}>
				<i
					className={`fas fa-moon ${
						theme === 'dark' ? 'opacity-100 text-light' : 'opacity-50'
					}`}></i>
			</label>
		</div>
	);
};

export default ModeToggler;
